import React, { useEffect, memo } from 'react';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchPublicDataTypes } from '@actions/data-types-actions';
import UnstyledHeading from '@components/shared/unstyled-heading';
import './public.scss';

const PublicLayout = ({ children }) => {
  const dispatch = useDispatch();
  const dataTypes = useSelector(state => state.dataTypes);
  const cityName = useSelector(state => state.config?.cityName);

  useEffect(() => dispatch(fetchPublicDataTypes()), [dispatch]);

  const requiredTypes = [
    'agency',
    'map_category_type',
    'map_category',
    'user'
  ];

  // Check that the configuration and all required data types are loaded before
  // displaying the page contents.
  if (requiredTypes.every(requiredType => !isEmpty(dataTypes[requiredType]))) {
    return (
      <div styleName="public-wrap">
        <UnstyledHeading rank={1} ariaOnly>Coordinate {cityName} public form</UnstyledHeading>
        <div styleName="public-body">
          {children}
        </div>
      </div>
    );
  }

  return null;
};

PublicLayout.propTypes = {
  children: PropTypes.element
};

export default memo(PublicLayout);
